import { render, staticRenderFns } from "./SettingsLicenseFile.vue?vue&type=template&id=5c531688&scoped=true&"
import script from "./SettingsLicenseFile.vue?vue&type=script&lang=js&"
export * from "./SettingsLicenseFile.vue?vue&type=script&lang=js&"
import style0 from "./SettingsLicenseFile.vue?vue&type=style&index=0&id=5c531688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c531688",
  null
  
)

export default component.exports